import React, { useState, useEffect } from "react";

import {
  getDepartmentList,
  deleteDepartment,
  updateDepartmentStatus,
  updateDepartment,
} from "../../services/Users-services";
import { useGlobalState } from "../../services/hostelConst";

import MasterTabel from "../../../src/views/dashboard/widget/MasterTabel.js";
import AddDepartmentForm from "../../components/FormComponents/AddDepartment";
const DepartmentTable = () => {
  const [isInitialized, setIsInitialized] = useState(false);
  const {
    _advanceFilterList,
    updateAdvanceFilterList,
    resetAdvanceFilterData,
  } = useGlobalState();
  useEffect(() => {
 
   
    setIsInitialized(true);
    return () => {};
  }, []);
  return (
    <MasterTabel
      getTableData={getDepartmentList}
      deleteRow={deleteDepartment}
      updateStatus={updateDepartmentStatus}
      updateRow={updateDepartment}
      tab1={"User Management"}
      tab2={"Departments"}
      actions={{
        status: true,
        edit: true,
        delete: true,
      }}
      // isStudentPortal={true}
      AddForm={AddDepartmentForm}
    />
  );
};

export default DepartmentTable;
